import React from 'react';

// Splits on http(s) URLs, keeping them as separate tokens.
const URL_SPLIT = /(https?:\/\/[^\s]+)/g;
const IS_URL = /^https?:\/\//;
const TRAILING = /[).,;:!?'"]+$/;

/**
 * Renders plain text with any http(s) URLs auto-converted to clickable links.
 * Preserves line breaks. URLs open in a new tab; clicks don't bubble to the
 * parent (so clicking a link inside a clickable row won't trigger the row).
 */
export const LinkifiedText = ({
  text,
  className = '',
  linkClassName = 'text-blue-600 underline hover:text-blue-800 break-all',
}) => {
  if (!text) return null;
  const parts = String(text).split(URL_SPLIT);
  return (
    <span className={className} style={{ whiteSpace: 'pre-wrap' }}>
      {parts.map((part, i) => {
        if (!part) return null;
        if (IS_URL.test(part)) {
          const m = part.match(TRAILING);
          const trail = m ? m[0] : '';
          const url = trail ? part.slice(0, -trail.length) : part;
          return (
            <React.Fragment key={i}>
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className={linkClassName}
                onClick={(e) => e.stopPropagation()}
                data-testid="linkified-url"
              >
                {url}
              </a>
              {trail}
            </React.Fragment>
          );
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </span>
  );
};

export default LinkifiedText;
